import { StepByStepFieldsFragment } from 'api/graphql-types';
import { StepByStepCard } from 'components/step-by-step-card/step-by-step-card';
import { Typography } from 'components/typography';
import { iterateHeading } from 'utils/iterate-heading';

import styles from './step-by-step-module.module.scss';

interface IStepByStepProps {
	module: StepByStepFieldsFragment;
}

const StepByStep = (props: IStepByStepProps): React.JSX.Element => {
	const backgroundColor = props.module?.defaultModuleOptions?.backgroundColor;

	return (
		<>
			{props.module.title?.value && (
				<Typography tag={props.module.title?.type || 'h2'} className={styles.title}>
					{props.module.title.value}
				</Typography>
			)}
			<div className={styles.cards}>
				{props.module.stepByStepCard?.map((card) => {
					return (
						<StepByStepCard
							key={card?.cardTitle}
							title={card?.cardTitle}
							description={card?.cardDescription ?? undefined}
							backgroundColor={backgroundColor}
							headingType={iterateHeading(props?.module?.title?.type)}
						/>
					);
				})}
			</div>
		</>
	);
};

export default StepByStep;
